import EpiApiClient from "@/services/serviceClients/epiApiClient";
import { HOVER_JOBS_API_PATH, HOVER_IMPORT_REPORT_API_PATH, HOVER_API_PATH, UPLOAD_SAS_TOKEN_API_PATH, HOVER_INVITE_TO_CAPTURE_API_PATH } from "@/config/constants";

class hoverService {

  static async getJobs(payload) {
    try {
      const response = await EpiApiClient.post(`${HOVER_JOBS_API_PATH}`, payload);
      return { success: true, data: response?.data?.results || [] };
    } catch (error) {
      return { success: false, error: error?.response?.data?.error_description || "request failed", data: [] };
    }
  }

  static async getRoofMeasurements(jobId) {
    try {
      const response = await EpiApiClient.get(`${HOVER_IMPORT_REPORT_API_PATH}${jobId}`);
      return { success: true, data: response?.data || [] };
    } catch (error) {
      return { success: false, error: error?.response?.data?.error_description || "request failed", data: [] };
    }
  }

  static async blueprintUpload(payload) {
    try {
      const response = await EpiApiClient.post(`${HOVER_API_PATH}blueprintupload`, payload);
      return { success: true, data: response?.data || [], error: null };
    } catch (error) {
      const errorMessage = error?.response?.data?.error_description || error?.message || "Request failed";
      console.error('hoverService.blueprintUpload failed:', errorMessage, error);
      return { success: false, data: null, error: errorMessage };
    }
  }

  static async getSasTokens(numberOfFiles) {
    try {
      const response = await EpiApiClient.get(`${UPLOAD_SAS_TOKEN_API_PATH}${numberOfFiles}`);
      return { success: true, data: response?.data || [], error: null };
    } catch (error) {
      const errorMessage = error?.response?.data?.error_description || error?.message || "Unable to retrieve SAS tokens";
      console.error('hoverService.getSasTokens failed:', errorMessage, error);
      return { success: false, data: null, error: errorMessage };
    }
  }

  static async inviteToCapture(payload) {
    try {
      const response = await EpiApiClient.post(HOVER_INVITE_TO_CAPTURE_API_PATH, payload);
      return { success: true, data: response?.data || null, error: null };
    } catch (error) {
      const errorMessage = error?.response?.data?.error_description || error?.message || "Failed to send invite";
      console.error('hoverService.inviteToCapture failed:', errorMessage, error);
      return { success: false, data: null, error: errorMessage };
    }
  }

}

export default hoverService;
